import { MULTI_FUNDS } from 'src/app/apv/subscription/constants/regime-fund.constant';

export const MULTI_FUNDS_MODAL_TEXTS = {
  title: 'Conoce más de los multifondos',
  closeLabel: 'Cerrar',
};

const DESCRIPTIONS: { [id: string]: string } = {
  A: 'Invierte entre un 40% y 80% de los ahorros en Renta Variable. Se considera como el más rentable a largo plazo.',
  B: 'Invierte entre un 25% y 60% de los ahorros en Renta Variable. Se le considera rentable a largo plazo.',
  C: 'Invierte entre un 15% y 40% de los ahorros en Renta Variable. Es rentable en el mediano plazo.',
  D: 'Invierte entre un 5% y 20% de los ahorros en Renta Variable. Se le considera estable y menos rentable que los fondos A y B a largo plazo.',
  E: 'Invierte sólo entre un 0% y 5% de los ahorros en Renta Variable. Se le considera el más conservador.',
};

export const MULTI_FUNDS_MODAL_TABS = [
  {
    id: 'que-son',
    label: '¿Qué son los multifondos?',
    intro:
      'Son las alternativas que tienes para invertir tus ahorros obligatorios y voluntarios. Son cinco opciones que van desde la letra A a la E, de mayor a menor riesgo.',
    subtitle: '¿Cómo invierte cada fondo?',
    bullets: [
      {
        strong: 'En Instrumentos de Renta fija:',
        text: ' Depósitos a plazo, Bonos, Letras Hipotecarias, Instrumentos Banco Central, entre otros. (Fondos menos riesgosos).',
      },
      {
        strong: 'Y en Instrumentos de Renta variable:',
        text: ' Acciones, Multifondos Inmobiliarios entre otros. (Fondos más riesgosos).',
      },
    ],
    funds: [],
  },
  {
    id: 'riesgo',
    label: 'De mayor a menor riesgo',
    intro: '',
    subtitle: 'De mayor a menor riesgo',
    bullets: [],
    funds: MULTI_FUNDS.map((fund) => ({
      ...fund,
      description: DESCRIPTIONS[fund.id],
    })),
  },
];
